import { useIdleLogout } from '@/hooks/useIdleLogout';

// No UI — just wires up the inactivity auto-logout timer for office roles.
// Mounted once inside the authenticated Layout shell.
export function IdleLogoutManager() {
  useIdleLogout();
  return null;
}
